import { Client } from "@xmpp/client"
import { getAllItems } from "./PubSub"
import { Element } from "@xmpp/xml"
import { wizardJid } from "../../jidUtils"
import XmppPubSubApi from "../xmppPubSubApi"
import { captureError } from "../../ErrorHandlers"
import { ReferenceRouteStatus } from "../../reducers/referenceRouteStatusesSlice"

const NODE = "urn:slickshift:reference-route:0"

export const retrieveAllReferenceRouteStatuses = async (
  xmpp: Client,
): Promise<ReferenceRouteStatus[]> => {
  const statuses = await getAllItems({
    xmpp,
    jid: wizardJid(xmpp.jid!),
    node: NODE,
    timeout: 4000,
  })

  const items = statuses
    .getChild("pubsub")
    ?.getChild("items")
    ?.getChildren("item") as [Element]

  return items.map((item) => {
    const referenceRoute = item.getChild("reference-route")

    const isOffRoute = referenceRoute?.getAttr("is_off_route") === "1"
    return {
      jid: item.getAttr("id"),
      isOffRoute,
    }
  })
}

export const subscribeToReferenceRouteStatuses = async (client: Client) => {
  try {
    await XmppPubSubApi.subscribe(client, wizardJid(client.jid!), NODE)
  } catch (error: any) {
    if (error.condition !== "item-not-found") {
      captureError(error, {
        origin: "XMPPOnOnline",
        extra: { message: "subscribeToReferenceRouteStatuses" },
      })
    }
  }
}
